export const purchaseHistoryConstants = {
    PURCHASEHISTORY_REQUEST: 'PURCHASEHISTORY_REQUEST',
    PURCHASEHISTORY_REQUEST_SUCCESS: 'PURCHASEHISTORY_REQUEST_SUCCESS',
    PURCHASEHISTORY_FAILURE: 'PURCHASEHISTORY_FAILURE'
};